'use client'

import { type FC } from 'react'
import { JsonLd } from 'react-schemaorg'
import { type CollectionPage } from 'schema-dts'

import { useGlobalConfigContext } from '../../../../global-config'
import { useNextPathname } from '../../../../next-pathname'

type StoryblokAkeneoCategoryJsonLdProps = {
  title?: string
}

export const StoryblokAkeneoCategoryJsonLd: FC<
  StoryblokAkeneoCategoryJsonLdProps
> = ({ title }) => {
  const { shopUrl } = useGlobalConfigContext()
  const pathname = useNextPathname()

  return (
    <JsonLd<CollectionPage>
      item={{
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: title,
        url: new URL(pathname, shopUrl).href,
      }}
    />
  )
}
